export default "__VITE_ASSET__CuY8kka5__"